import { render } from "./AddLessonUnitForBatch.vue?vue&type=template&id=59dc3972&scoped=true"
import script from "./AddLessonUnitForBatch.vue?vue&type=script&lang=js"
export * from "./AddLessonUnitForBatch.vue?vue&type=script&lang=js"

import "./AddLessonUnitForBatch.vue?vue&type=style&index=0&id=59dc3972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dc3972"]])

export default __exports__